import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-semibold" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Lageplanübersicht")
const _hoisted_4 = { class: "float-right" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header bg-white" }
const _hoisted_11 = { class: "font-weight-semibold" }
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = {
  key: 0,
  class: "alert alert-info col-12"
}
const _hoisted_16 = { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, [
        _createElementVNode("a", {
          href: _ctx.baseFileUrl + '/getFile.php?t=LageplaeneProjekte&_token=' + _ctx.user.accessToken + '&_forceDownload=true',
          target: "_blank",
          class: "btn btn-primary"
        }, _hoisted_7, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col-12"
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h5", _hoisted_11, [
                _createTextVNode(_toDisplayString(project.p_firma) + " | ", 1),
                _createElementVNode("small", null, "#" + _toDisplayString(project.pid), 1)
              ]),
              _createElementVNode("span", _hoisted_12, _toDisplayString(project.p_strasse) + " " + _toDisplayString(project.p_hnr) + ", " + _toDisplayString(project.p_plz) + " " + _toDisplayString(project.p_ort), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (!project.locationMaps || project.locationMaps.length <= 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Es sind keine Lagepläne in diesem Objekt vorhanden "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.locationMaps, (map, mIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: mIndex,
                    class: "col-12 col-md-6 col-xl-4 position-relative"
                  }, [
                    _createElementVNode("legend", _hoisted_16, _toDisplayString(map.lageplanName), 1),
                    _createElementVNode("a", {
                      class: "cursor-pointer",
                      onClick: ($event: any) => (_ctx.showLocationMap(map.target, map.lageplanName))
                    }, [
                      _createElementVNode("img", {
                        src: map.target,
                        class: "w-100"
                      }, null, 8, _hoisted_18)
                    ], 8, _hoisted_17)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}